var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactsFilterMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_13712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.5C6.5 6.03043 6.71071 6.53914 7.08579 6.91421C7.46086 7.28929 7.96957 7.5 8.5 7.5C9.03043 7.5 9.53914 7.28929 9.91421 6.91421C10.2893 6.53914 10.5 6.03043 10.5 5.5C10.5 4.96957 10.2893 4.46086 9.91421 4.08579C9.53914 3.71071 9.03043 3.5 8.5 3.5C7.96957 3.5 7.46086 3.71071 7.08579 4.08579C6.71071 4.46086 6.5 4.96957 6.5 5.5V5.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C9.69347 1 10.8381 1.47411 11.682 2.31802C12.5259 3.16193 13 4.30653 13 5.5C13 7.66733 9.57867 12.518 8.70267 13.7247C8.67932 13.7565 8.64881 13.7824 8.6136 13.8002C8.57839 13.8181 8.53947 13.8274 8.5 13.8274C8.46053 13.8274 8.42161 13.8181 8.3864 13.8002C8.35119 13.7824 8.32068 13.7565 8.29733 13.7247C7.42133 12.518 4 7.66733 4 5.5C4 4.30653 4.47411 3.16193 5.31802 2.31802C6.16193 1.47411 7.30653 1 8.5 1V1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.486 12.3564C14.3073 12.7171 15.5 13.3191 15.5 14.0004C15.5 15.1051 12.3667 16.0004 8.5 16.0004C4.63333 16.0004 1.5 15.1051 1.5 14.0004C1.5 13.3204 2.68733 12.7198 4.5 12.3584",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_13712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsFilterMarker);
export default __webpack_public_path__ + "static/media/ContactsFilterMarker.6023375a0cf222dbe3cfc5344125c376.svg";
export { ForwardRef as ReactComponent };